import {ChevronDown} from 'lucide-react'
import { useState } from 'react'

const FAQS = [
  {
    question: 'How much does a tattoo cost near me?',
    answer: 'Local tattoo costs vary by region: expect $80-$150 for small pieces (2-3 sq. in.), $150-$450 for medium designs (a hand-sized piece), and $800-$3,000+ for large works like full sleeves or back pieces. Rates depend heavily on your artist\'s tier, studio minimums, and regional cost multipliers (low-cost areas run 15% below standard metro rates, while high-cost cities run 30% above).',
  },
  {
    question: 'What is the tattoo hourly rate?',
    answer: 'Tattoo hourly rates typically fall into three tiers: Apprentice artists charge around $90/hour, Professional Studio artists charge around $160/hour, and Elite Specialist artists (often with waitlists and portfolio recognition) charge $270/hour or more. Complex color and photo-realism work is billed at the same hourly rate but requires significantly more hours.',
  },
  {
    question: 'How many sessions are required for laser tattoo removal?',
    answer: 'Most tattoos require 6-10 laser removal sessions spaced 6-8 weeks apart, though this varies by ink density, color, and skin tone. Black ink clears fastest; vibrant multi-color ink can require 1.5x more sessions. Newer tattoos (under 1 year) often need 2 additional sessions, while older, faded tattoos may need 2 fewer. Picosecond lasers can reduce total sessions by roughly 15% compared to older Q-Switched technology.',
  },
  {
    question: 'What is the average tattoo cost for a full sleeve?',
    answer: 'A full sleeve tattoo typically costs between $1,500 and $5,000+, depending on complexity, color work, and artist tier. At 100+ square inches of coverage with shaded black & grey work at a Professional Studio rate ($160/hr), most full sleeves take 15-30 hours to complete across multiple sessions.',
  },
  {
    question: 'Why do rib and face tattoos cost more?',
    answer: 'Ribs, feet, and face/scalp areas are considered premium-charge zones because thin skin, high nerve density, and close proximity to bone make the work slower and more physically demanding for the artist. These placements carry a 1.25x-1.3x pricing multiplier compared to standard forearm placements.',
  },
  {
    question: 'Is laser tattoo removal cost per session fixed?',
    answer: 'No. Laser tattoo removal cost per session is calculated by the treatment area (square inches) multiplied by a per-square-inch base rate ($12 for Nanosecond Q-Switched, $18 for Picosecond technology). Larger tattoos and multi-color ink increase per-session cost, while smaller, older, faded tattoos cost less per visit.',
  },
]

function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0)

  return (
    <section id="faq" className="bg-[#0e0c0a] px-4 py-20 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-3xl">
        <div className="text-center">
          <h2 className="font-serif text-3xl font-bold text-white sm:text-4xl">
            Frequently Asked Questions
          </h2>
          <p className="mt-3 text-slate-400">
            Factual answers to the most common tattoo and laser removal cost questions.
          </p>
        </div>

        <div className="mt-10 space-y-3">
          {FAQS.map((faq, index) => {
            const isOpen = openIndex === index
            return (
              <div key={faq.question} className="rounded-xl border border-white/10 bg-white/[0.03]">
                <button
                  type="button"
                  onClick={() => setOpenIndex(isOpen ? null : index)}
                  aria-expanded={isOpen}
                  className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left"
                >
                  <span className="font-medium text-white">{faq.question}</span>
                  <ChevronDown
                    className={`h-5 w-5 flex-shrink-0 text-amber-400 transition-transform ${isOpen ? 'rotate-180' : ''}`}
                    aria-hidden="true"
                  />
                </button>
                {isOpen && (
                  <div className="px-6 pb-5 text-sm leading-relaxed text-slate-400">
                    {faq.answer}
                  </div>
                )}
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}

export default Faq
